<template>
  <div v-if="!!company.id">
    <div class="d-flex align-items-center justify-content-between">
      <CompanyRLSDownloadButton />
      <CompanyRLSUploadButton @success="onUploadSuccess" />
    </div>

    <b-row class="mt-4">
      <b-col
        v-for="(rlsGroup, key) in fields"
        :key="`company-rls-group-${key}`"
        xl="3"
        md="6"
        class="mb-4"
      >
        <CompanyRLSDropdown
          :value="company[key]"
          :rls-group="rlsGroup"
          :placeholder="rlsGroup"
          multiple
          @saved="(rlsGroup) => onDropdownSaved(rlsGroup)"
        />

        <CompanyRLSList :ref="`${rlsGroup}ListRef`" :rls-group="rlsGroup" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { defineComponent, ref, nextTick } from '@vue/composition-api'
import { createVuexHelpers } from 'vue2-helpers'

import { useDOMPageTitle } from '@composables'
import {
  CompanyRLSDownloadButton,
  CompanyRLSUploadButton,
  CompanyRLSDropdown,
  CompanyRLSList
} from '@components/company'

export default defineComponent({
  name: 'ManageCompanyRLS',
  components: {
    CompanyRLSDownloadButton,
    CompanyRLSUploadButton,
    CompanyRLSDropdown,
    CompanyRLSList
  },
  setup() {
    const { setDOMPageTitle } = useDOMPageTitle()

    const { useGetters } = createVuexHelpers()

    const { company } = useGetters(['company'])

    setDOMPageTitle(company.value.name || '')

    const fields = {
      rls_tpa_ids: 'TPA',
      rls_underwriter_ids: 'Underwriter',
      rls_coverholder_ids: 'Coverholder',
      rls_broker_ids: 'Broker'
    }

    const TPAListRef = ref(null)
    const UnderwriterListRef = ref(null)
    const CoverholderListRef = ref(null)
    const BrokerListRef = ref(null)

    const onDropdownSaved = async (rlsGroup) => {
      await nextTick()

      if ('TPA' === rlsGroup) {
        TPAListRef.value[0].fetchRLSGroupItems()
      } else if ('Underwriter' === rlsGroup) {
        UnderwriterListRef.value[0].fetchRLSGroupItems()
      } else if ('Coverholder' === rlsGroup) {
        CoverholderListRef.value[0].fetchRLSGroupItems()
      } else if ('Broker' === rlsGroup) {
        BrokerListRef.value[0].fetchRLSGroupItems()
      }
    }

    const onUploadSuccess = async () => {
      await nextTick()

      if (!!TPAListRef.value) TPAListRef.value[0].fetchRLSGroupItems()

      if (!!UnderwriterListRef.value)
        UnderwriterListRef.value[0].fetchRLSGroupItems()

      if (!!CoverholderListRef.value)
        CoverholderListRef.value[0].fetchRLSGroupItems()

      if (!!BrokerListRef.value) BrokerListRef.value[0].fetchRLSGroupItems()
    }

    return {
      company,

      fields,

      TPAListRef,
      UnderwriterListRef,
      CoverholderListRef,
      BrokerListRef,

      onDropdownSaved,
      onUploadSuccess
    }
  }
})
</script>

<style scoped>
.advanced-dropdown >>> .list-group-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.advanced-dropdown >>> .list-group-item .input-group {
  max-width: 110px;
}

.advanced-dropdown >>> .list-group-item .input-group-text {
  padding-right: 6px;
  padding-left: 0;
  border: 0;
}

.advanced-dropdown >>> .list-group-item .share-input {
  max-width: 100px;
}
</style>
